import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ModuleLocatiiService } from '../module-locatii.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { ModulLocatieActiva, ModulLocatieActivaUpdate } from '../module-locatii.interface';
import { GhiseuModuleService } from '../../ghiseu-module/ghiseu-module.service';
import { LocatiiService } from '../../locatii/locatii.service';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';

@Component({
    selector: 'app-edit-module-locatii',
    templateUrl: './edit-module-locatii.component.html',
    styleUrls: ['./edit-module-locatii.component.scss']
})
export class EditModuleLocatiiComponent implements OnInit {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    module!: any[];
    locatii!: any[];

    form: FormGroup = new FormGroup({
        id_modul: new FormControl(this.data.id_modul, [Validators.required, notDefaultValidator('-1')]),
        id_locatie: new FormControl(this.data.id_locatie, [Validators.required, notDefaultValidator('-1')]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditModuleLocatiiComponent>,
        private moduleLocatiiActiveService: ModuleLocatiiService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private ghiseuModuleService: GhiseuModuleService,
        private locatiiService: LocatiiService
    ) {
        this.processToken();
    }

    ngOnInit(): void {
        this.loadModule();
        this.loadLocatii();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.moduleLocatiiActiveService.setToken(token);
        });
    }

    loadModule() {
        this.isLoading = true;
        this.ghiseuModuleService.getModule().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.module = res;
            },
            error: (err) => {
                console.error('Error in get ghiseu module: ', err);
            }
        })
    }

    loadLocatii() {
        this.isLoading = true;
        this.locatiiService.getLocatii().pipe(
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {

                this.locatii = res;
            },
            error: (err) => {
                console.error('Error in get locatii: ', err);
            }
        })
    }

    submitForm() {
        this.isLoading = true;

        const { id_modul, id_locatie } = this.form.value as ModulLocatieActiva;

        const updatedModulLocatiiActive: ModulLocatieActivaUpdate = {
            id_modul,
            id_locatie,
            id: this.data.id,
        };

        this.moduleLocatiiActiveService
            .updateModulLocatii(updatedModulLocatiiActive)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
